<template>
    <v-dialog width="400" v-model="dialog">
        <v-card class="pa-6">
            <v-card-title>Добавить услугу в акт</v-card-title>
            <v-data-table :headers="headers" :items="items" hide-default-footer disable-pagination disable-sort disable-filtering>
                <template v-slot:item.selected="{ item }">
                    <div>
                        <v-checkbox v-model="item.selected" :label="item.serv_type_name" color="$vuetify.theme.themes.light.primary" />
                    </div>
                </template>
            </v-data-table>
            <v-card-actions class="justify-end">
                <v-btn @click="dialog = false" color="gray" outlined rounded>отмена</v-btn>
                <v-btn @click="addService" color="gray" rounded class="white--text">Добавить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: 'AddServiceActDialog',
    props: ['value', 'items'],
    data: function() {
        return {
            headers: [
                {
                    text: 'Услуга',
                    value: 'selected'
                }
            ]
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        addService() {
            this.$emit('confirmAddServiceAct');
        }
    }
};
</script>

<style scoped></style>
